(() => {
  if (window.__perfumiarzFooterInitialized) return;
  window.__perfumiarzFooterInitialized = true;

  const sortAlphabeticalFooterMenus = (scope = document) => {
    const footerCollator = new Intl.Collator(document.documentElement.lang || 'en', {
      sensitivity: 'base'
    });

    scope.querySelectorAll('[data-alphabetical-footer-menu]').forEach((list) => {
      Array.from(list.children)
        .sort((firstItem, secondItem) =>
          footerCollator.compare(firstItem.textContent.trim(), secondItem.textContent.trim())
        )
        .forEach((item) => list.appendChild(item));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sortAlphabeticalFooterMenus(document));
  } else {
    sortAlphabeticalFooterMenus(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    sortAlphabeticalFooterMenus(event.target);
  });
})();
